import {useQuery} from '@tanstack/react-query'
import getEmployeeQR from './api/getEmployeeQR'
import {useTranslation} from 'react-i18next'

const useEmployeeQR = ({
    qrId,
    name,
    role,
}: {
    qrId: number
    name: string
    role: string
}) => {
    const {
        i18n: {language},
    } = useTranslation()
    const queryFunc = () => getEmployeeQR({qrId, name, role, language})
    return useQuery(['employee', 'qr', qrId, name, role, language], queryFunc)
}

export default useEmployeeQR
